import axios from "axios"
import Repository from "./Repository"

const iiifURL = process.env.VUE_APP_IIIF_API_URL_BASE

export default {
    getInfo(uuid) {
        if(!uuid) return ;

        return axios.create({baseURL:iiifURL}).get(uuid + '/info.json')
    }

}
